"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteComponent = void 0;
var react_1 = __importStar(require("react"));
var useDynamicScript_1 = require("./useDynamicScript");
var RemoteComponent = function (_a) {
    var remoteScope = _a.remoteScope, remoteModule = _a.remoteModule, url = _a.url, nestedProps = _a.nestedProps, dependencies = _a.dependencies, _b = _a.fallback, fallback = _b === void 0 ? react_1.default.createElement("div", null, "Loading ...") : _b;
    var _c = __read((0, react_1.useState)(null), 2), shouldRender = _c[0], setShouldRender = _c[1];
    var _d = (0, useDynamicScript_1.useDynamicScript)(url), ready = _d.ready, failed = _d.failed;
    (0, react_1.useEffect)(function () {
        if (!remoteScope || !remoteModule)
            throw new Error("You must specify scope and module to import a Remote Component");
        if (!ready || failed || !global)
            return;
        global[remoteScope].init(dependencies);
        var Component = (0, react_1.lazy)(function () {
            return global[remoteScope]
                .get(remoteModule)
                .then(function (factory) { return factory(); });
        });
        setShouldRender({ Component: Component });
    }, [failed, ready, remoteModule, remoteScope, dependencies]);
    if (!shouldRender)
        return null;
    var Component = shouldRender.Component;
    return (react_1.default.createElement(react_1.Suspense, { fallback: fallback },
        react_1.default.createElement(Component, __assign({}, nestedProps))));
};
exports.RemoteComponent = RemoteComponent;
